





































































































import {
  getCorrespondences,
  getSortOrder,
  downloadDocument,
  ICorrespondence,
  correspondenceHeader,
  sortOrderQueryString,
  getDocUrl,
} from '../../api/index';
import { apiErrorHelper } from '../../api/apiErrorHelper';
import LoadingBox from '../LoadingBox/LoadingBox.vue';
import Pagination from '../subComponents/Pagination/Pagination.vue';
export default {
  name: 'Correspondence',
  components: {
    LoadingBox,
    Pagination,
  },
  data() {
    return {
      correspondences: {
        items: [],
        headers: [],
        headersTablet: [],
        totalCount: 0,
      },
      loading: true,
      options: {},
      initialLoading: true,
      currentSort: {
        page: 1,
        sortBy: correspondenceHeader.Date,
        sortDesc: false,
      },
      downloadingDocuments: [],
      downloading: false,
    };
  },
  props: {
    fields: {
      type: Object,
      default: () => ({
        LoadingText: { value: '' },
        NoDataText: { value: '' },
      }),
    },
  },
  methods: {
    async getDataFromApi(displayLoading) {
      this.loading = displayLoading;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      let sortOrder = getSortOrder(sortBy, sortDesc);
      try {
        let corespondenceItems = await getCorrespondences(page, itemsPerPage, sortOrder);
        if (corespondenceItems) {
          this.correspondences = corespondenceItems;
        }
      } catch (error) {
        apiErrorHelper(this.$router, error);
      }
      this.loading = false;
    },
    goToDownload(id, name, type) {
      // We will allow only one download at the time... So check if a download already started
      if (this.downloading) {
        return;
      }

      // Start the Download Spinning
      this.downloadingDocuments.push(id);
      this.downloading = true;
      this.$router.push(getDocUrl(id, name, type)).catch((completed) => {
        // Download will not open a new ROUTE instead navigation will be aborted (next(false)) and Download will start.
        if (completed == false) {
          // Stop the Download Spinning
          this.downloadingDocuments.splice(this.downloadingDocuments.indexOf(id), 1);
          this.downloading = false;
        }
      });
    },
  },
  watch: {
    options: {
      async handler() {
        if (this.initialLoading) {
          this.initialLoading = false;
          return;
        }

        // IMPORTANT Default bevaviour from component is a 3 ways clicking for sort:
        // 1- click once: set the desc order
        // 2- click second time will set the asc
        // 3- click a thrid time remove all sort...
        // IMPORTANT we want to have only asc and desc... so we need to update a few thing:
        if (this.options.sortBy == null || this.options.sortBy.length <= 0) {
          // Forcing the sort by to stay on a value - avoid the 3 third state above
          this.options.sortBy = this.currentSort.sortBy;
        }
        if (this.options.sortDesc == null || this.options.sortDesc.length <= 0) {
          // Forcing the sort by to stay on a value - avoid the 3 third state above
          let sDesc = new Array();
          sDesc.push(false);
          this.options.sortDesc = sDesc;
        }

        // We need to ensure the API call is made only once - we can compare the new sort parameters vs the current
        // dont execute API if nothing change
        if (
          this.options.page == this.currentSort.page &&
          this.options.sortBy == this.currentSort.sortBy &&
          this.options.sortDesc == this.currentSort.sortDesc
        ) {
          return;
        }

        // Set the current sort parameters
        this.currentSort.page = this.options.page;
        this.currentSort.sortBy = this.options.sortBy;
        this.currentSort.sortDesc = this.options.sortDesc;

        await this.getDataFromApi(false);

        // After getting the results -> scroll up to the top of the table
        if (!this.initialLoading) {
          return this.$vuetify.goTo('#correspondence-table-list', { offset: 60 });
        }
      },
      deep: true,
    },
  },
  async mounted() {
    try {
      // Set the default sorting for Data Table
      let sortDefault = new Array();
      sortDefault.push(this.currentSort.sortBy);
      this.options.sortBy = sortDefault;

      let sortDescDefault = new Array();
      sortDescDefault.push(this.currentSort.sortDesc);
      this.options.sortDesc = sortDescDefault;

      const correspondences: ICorrespondence = await this.getDataFromApi(true);
      if (correspondences) {
        this.correspondences = correspondences;
      }
    } catch (error) {
      apiErrorHelper(this.$router, error);
    }
  },
  computed: {
    tableHeaders() {
      if (this.correspondences.headers.length <= 0) {
        return [];
      } else {
        if (this.$vuetify.breakpoint.smOnly || this.$vuetify.breakpoint.mdOnly) {
          return this.correspondences.headersTablet;
        } else {
          return this.correspondences.headers;
        }
      }
    },
    nbPageVisible() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 7;
      } else {
        if (this.correspondences.totalPages > 9) {
          return 9;
        } else {
          return this.correspondences.totalPages;
        }
      }
    },
    displayPagination() {
      return this.correspondences.totalPages > 1 ? true : false;
    },
    hideDefaultHeader() {
      if (!this.loading && this.correspondences.totalCount < 1) {
        return true;
      }
      return false;
    },
  },
};
